import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	selector: '[vc-clicked]',
	standalone: false,
})
export class ClickedDirective {
	@Output() clicked = new EventEmitter<void>();

	@HostListener('click', ['$event'])
	onClick(event: Event) {
		event.stopPropagation();
		this.clicked.emit();
		return false;
	}
}
